export default __webpack_public_path__ + "static/ACCIDENTES-a701315b1d04aa6ab350c94941866771.jpg";